import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import software from './routes/remote'
import company from './routes/company'
import home from './routes/home'
import reports from './routes/reports'
import history from './routes/history'
import pages from './routes/pages'
import components from './routes/user-management'
import sync from './routes/sync'
import logout from './routes/logout'
import usersFeedback from './routes/user-feedback'
import maintenance from './routes/maintenance'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...software,
    ...company,
    ...home,
    ...pages,
    ...reports,
    ...components,
    ...sync,
    ...history,
    ...usersFeedback,
    {
      path: '*',
      redirect: 'error-404',
    },
    ...logout,
  ],
  // routes: [
  //   ...maintenance,
  //   {
  //     path: '*',
  //     redirect: 'maintenance'
  //   }
  // ]
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login', query: { token: to.query.token } })
    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
